import { ApiError } from 'src/api/requests'
import { message } from 'src/components'

export const formErrorHandler = (
  data: ApiError
): { name: string[]; errors: string[] }[] => {
  const errorList: { name: (string | number)[]; errors: string[] }[] = []

  const processNestedErrors = (
    obj: ApiError,
    prefix: (string | number)[] = []
  ) => {
    // Guard against null/undefined or non-object error payloads (e.g. network
    // errors, or responses without a `body.errors` object) — Object.entries on
    // those throws "Cannot convert undefined or null to object".
    if (!obj || typeof obj !== 'object') return

    for (const [key, value] of Object.entries(obj)) {
      const fieldName = [...prefix, key]
      if (Array.isArray(value)) {
        value.forEach((error: string, index: number) => {
          if (typeof error === 'object' && error !== null) {
            processNestedErrors(error, [...fieldName, index])
          } else {
            errorList.push({
              name: fieldName,
              errors: [error]
            })
          }
        })
      } else if (typeof value === 'object' && value !== null) {
        processNestedErrors(value, fieldName)
      } else {
        errorList.push({
          name: fieldName,
          errors: [value]
        })
      }
    }
  }

  processNestedErrors(data)

  errorList.forEach((item) => {
    message.error(`${item.errors.join('.')}`)
  })

  return errorList as { name: string[]; errors: string[] }[]
}
